<script>
    import Main from "../components/Main.svelte"

    export let content

</script>

<Main { content } />